<template>
  <RModal ref="modal" title="Update usage column title" max-width="475px" @cancel="$event()" @ok="save">
    <RInput
      v-model="newTitle"
      autofocus
      no-feedback-icon
      class="q-mt-md"
      label="Usage column detail"
      hint="The detail you enter here will be appended to 'Usage', so if you enter
'Downloads' the final column name will be 'Usage Downloads'"
      @keyup.enter="save"
    />
  </RModal>
</template>

<script>
import RModal from '@/ui/RModal'

export default {
  components: {
    RModal
  },

  data: () => ({
    newTitle: ''
  }),

  methods: {
    show(usageTitle) {
      this.newTitle = usageTitle
      this.$refs.modal.show()
    },

    save() {
      if (!this.newTitle.trim()) return
      this.$emit('new-title', this.newTitle)
      this.newTitle = ''
      this.$refs.modal.hide()
    }
  }
}
</script>
